import React, { Suspense, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetTraining, TrainingEnrollment } from "../Services/SelfLearning";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import moment from "moment";
const ComponentLoader = React.lazy(() => import("../../../../Shared/Sidebar/ComponentLoader"));
const defaultImage = '/images/placeholder_profile.png';

let enrolledUserId = 0;
function TrainingDetail() {
    const [IsLoading, setIsLoading] = useState(false);
    const [trainingList, setTrainingList] = useState([]);
    const [scheduleDatas, setScheduleDatas] = useState([]);
    const [enrolledUserList, setEnrolledUserList] = useState([]);
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const { id } = useParams();

    useEffect(() => {
        getTraining()
    }, [])

    const handleImageError = useCallback((event) => {
        event.target.src = defaultImage;
    }, []);

    async function getTraining() {
        setIsLoading(true);
        let params = {
            "OrgId": 0,
            "TrainingId": Number(id),//101,
            "UserId": userDetails.EmpId,
        }
        try {
            let responce = await GetTraining(params)
            setTrainingList(responce?.Data?.trainingsList[0])
            setScheduleDatas(responce?.Data?.scheduleDatas)
            enrolledUserId = responce?.Data?.enrolledUserLists?.filter((el) =>
                el.userId == userDetails.EmpId
            )
            setEnrolledUserList(responce?.Data?.enrolledUserLists);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    async function trainingEnrollment(type) {
        let trainingStatus
        if(type==1){
            trainingStatus = true;
        }else {
            trainingStatus =false;
        }
        if (userDetails.OrgId && id && userDetails.EmpId) {
            setIsLoading(true);
            let params = {
                "orgId": userDetails.OrgId,
                "trainingId": Number(id),
                "userId": userDetails.EmpId,
                "isTrainingStatus": trainingStatus
            }
            try {
                await TrainingEnrollment(params);
                await getTraining();
                setIsLoading(false);
            } catch (error) {
                console.error('Error during enrollment:', error);
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        } else {
            setIsLoading(false);
        }

    }

    return (
        <div className="position-relation">
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn">
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>
                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="/InstructorTrainingDashboard" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>
            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">
                <div className="row trainingmain-div">
                    <div className="col-xl-10">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body p-5">
                                    <div className="coursedetail">
                                        <strong className=''>Topic</strong>
                                        <div className="des">
                                            <h4 className="block-heading">{trainingList?.title}</h4>
                                            <p className="block-text mb-2">{trainingList?.content}</p>
                                            <div className="students pb-0 createdby">
                                                <div className="h-avatar is-small">
                                                    <img className="avatar" src="/images/avatar/6.jpg" alt="" />
                                                </div>
                                                <a className="link is-dark-primary">Project Manager : {trainingList?.hostName}</a>
                                            </div>
                                        </div>
                                        <Link to="/InstructorTrainingDashboard" className="add-more">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
                                                  16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
                                                  07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
                                                  .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg>
                                        </Link>
                                    </div>
                                    <div className="more-jobdetail mt-3">
                                        <strong className=''>Course Description</strong>
                                        <p>{trainingList?.description}</p>

                                        <div className="students">
                                            {enrolledUserList?.map((profileImg) =>
                                                <div className="h-avatar is-small">
                                                    <img className="avatar" src={profileImg?.profileImage || defaultImage} onError={handleImageError} width="32" style={{ 'opacity': '1' }} />
                                                </div>)}
                                            {/* <div className="h-avatar is-small">
                                                <img className="avatar" src="/images/avatar/4.jpg" alt="" />
                                            </div>
                                            <div className="h-avatar is-small">
                                                <img className="avatar" src="/images/avatar/5.jpg" alt="" />
                                            </div>
                                            <div className="h-avatar is-small">
                                                <img className="avatar" src="/images/avatar/6.jpg" alt="" />
                                            </div>
                                            <div className="h-avatar is-small">
                                                <img className="avatar" src="/images/avatar/7.jpg" alt="" />
                                            </div> */}
                                            <div className="h-avatar is-small">
                                                <span className="avatar is-fake is-dark-bg-2">
                                                    <span>+{enrolledUserList?.length}</span>
                                                </span>
                                            </div>
                                            <a className="link is-dark-primary">Enrolled Students</a>
                                        </div>
                                        <strong className='slot'>
                                            {trainingList?.availableSlot}/{trainingList?.totalSlot} Slot Available</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="more-jobdetail p-3">
                                        <h5 className='for-course mb-0'>Scheduled
                                            {trainingList?.status == 'Open' ?
                                                <Link to={`/InstructorTrainingDashboard/TrainingDetail/ScheduleTraning/${id}`} className="add-opt">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                                    </svg>Add
                                                </Link>
                                                : ''
                                            }

                                        </h5>
                                        <div className="Courselist-wise mt-3">
                                            <div className="tab-content">
                                                <div className="shortlisted">
                                                    <div className="tab-content">
                                                        <div id="addmodule">
                                                            {scheduleDatas?.map((lst) => (
                                                                <div className="boxs">
                                                                    <Link to="/InstructorTrainingDashboard">
                                                                        <img src="/images/org-img/learn/done.svg" />
                                                                        <div className="position-relatives">
                                                                            <strong>{lst?.title}</strong>
                                                                            <p className="">{moment(lst?.startDate).format('MMM DD YYYY')} </p>
                                                                        </div>
                                                                        <time>Timing • {lst?.startTime?.slice(0, 5)} - {lst?.endtime?.slice(0, 5)}</time>
                                                                        <img src="/images/org-img/learn/lock.svg" />
                                                                    </Link>
                                                                </div>))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {trainingList?.status == 'Open' ?
                                        (scheduleDatas != 0 ? <div className="buy-buttonsss">
                                            {trainingList?.isUserEnrolled >= 1 ?
                                                <button onClick={() => trainingEnrollment(trainingList?.isUserEnrolled)} className="enrolled">Enrolled</button>
                                                : <button onClick={() => trainingEnrollment(trainingList?.isUserEnrolled)} className="enroll">Enroll Now</button>
                                            }
                                            <button className="wishlist">Cancel</button>
                                        </div> : <p>Schedule not available.</p>)
                                        : <p>Schedule already closed.</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {IsLoading ? <Suspense >
                <ComponentLoader />
            </Suspense> : ''}
        </div>
    )
}

export default TrainingDetail;